const getFinishTime = (started: number, duration: number) => {
  return new Date(new Date(started).getTime() + duration * 60 * 1000).getTime();
};

export default getFinishTime;
